import clsx from 'clsx'
import React from 'react'

export const CustomProgress = ({
  currentStep = 0,
  lastStep = 4,
}: {
  currentStep?: number
  lastStep?: number
}) => {
  const steps = Array.from({ length: lastStep })

  return (
    <div className="max-w-[376px] mt-3 mx-auto w-full flex gap-1">
      {steps.map((_, index) => (
        <div
          key={index}
          className={clsx(
            'h-1 flex-1 rounded-full transition-colors',
            index < currentStep ? 'bg-[#349760]' : 'bg-[#101A3614]',
          )}
        />
      ))}
    </div>
  )
}
